import clsx, {} from 'clsx';
/**
 * Join class names. The kit's own classes are plain CSS (`clav-*`) rather than Tailwind utilities,
 * so there is nothing to merge or deduplicate — an app's `className` is simply appended and wins by
 * source order, because its stylesheet comes after the kit's.
 */
export function cx(...values) {
    return clsx(values);
}
//# sourceMappingURL=cx.js.map